// extracted by mini-css-extract-plugin
export default {"MobileView":"QfG8J","getLinkCaption":"fglt9","icon":"-T2Bx","title":"mJA7C","caption":"LB-1q","skeleton-progress":"Ad8Qk"};